import {
  Contractor,
  ContractorParams,
  DashboardTopEntityResponse, TopArtist,
  TopTrack,
  useMusicApi
} from "../../api/useMusicApi";
import { useTranslation } from "../../hooks/useTranslation";
import { useLoading } from "../../hooks/use-loading";
import React, { useCallback, useEffect, useState } from "react";
import { PartialNullable } from "../../types";
import { toast } from "react-toastify";
import { Preloader } from "../../components/Preloader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeadphones } from "@fortawesome/free-solid-svg-icons";
import { EmptyTablePlaceholder } from "../../components/Table/EmptyTablePlaceholder";
import cn from "classnames";

type Props = {
  contractorId: number | string | null;
  contractors: Contractor[]
}

export const TopArtistsPrevWeekWidget: React.FC<Props> = ({ contractorId }) => {
  const { t } = useTranslation();
  const { getTopArtistPrevWeek } = useMusicApi();
  const { loadings, stopLoading, startLoading } = useLoading({
    fetchData: true
  });

  const [data, setData] = useState<DashboardTopEntityResponse<TopArtist> | null>(null);

  useEffect(() => {
    if (contractorId != null) {
      void fetchData({ contractor_id: contractorId } as any);
    }
  }, []);

  const fetchData = useCallback(async (params: PartialNullable<ContractorParams>) => {
    try {
      if (params.contractor_id == null) {
        return;
      }

      startLoading("fetchData");
      const response = await getTopArtistPrevWeek(params);
      setData(response);
    } catch (e) {
      toast.error(t("unexpected error"));
    } finally {
      stopLoading("fetchData");
    }
  }, []);

  useEffect(() => {
    void fetchData({ contractor_id: contractorId } as any);
  }, [contractorId]);

  return <>
    <div className={"w-full border border-gray-500 rounded p-[18px] h-full min-h-[240px] flex flex-col"}>
      <div className={"flex items-center justify-between"}>
        <div className={"font-[500] text-[16px]"}>
          {t("dashboard.top_artists_prev_week")}
        </div>
      </div>
      <div className={cn("flex flex-col text-[13px] mt-[24px] h-full", {
        "justify-center": (data?.data?.length ?? 0) === 0
      })}>
        {loadings.fetchData && <Preloader size={"3x"} className={"text-muted"} />}
        {
          !loadings.fetchData && (data?.data?.length ?? 0) > 0
            ? data?.data?.map(r => {
              return <div
                key={r.artist_name}
                className={"flex gap-[12px] p-[8px] rounded-[24px] items-center justify-between hover:bg-gray-100"}>
                <div className={"flex gap-[12px] items-center"}>
                  <div className={"max-w-[300px] text-[12px] text-muted truncate"}>{r.artist_name}</div>
                </div>
                <div className={"flex gap-[12px] items-center"}>
                  <div className={"flex items-center gap-[4px]  text-left"}>
                    {Intl.NumberFormat("ru-RU").format(r.streams)}
                    <FontAwesomeIcon className={"text-[13px] w-[20px] text-gray-400"} icon={faHeadphones} />
                  </div>
                </div>
              </div>;
            })
            : !loadings.fetchData && <EmptyTablePlaceholder />
        }
      </div>
    </div>
  </>;
};
